// @ts-nocheck
import React, { createContext, useContext, useMemo } from 'react';

const PopupContext = createContext(false);

export function PopupProvider({ children }) {
    const isPopupMode = useMemo(() => {
        try {
            if (window.opener && window.opener !== window) return true;
        } catch (_) { /* cross-origin opener */ }
        const params = new URLSearchParams(window.location.search);
        return params.get('embed') === '1';
    }, []);

    return (
        <PopupContext.Provider value={isPopupMode}>
            {children}
        </PopupContext.Provider>
    );
}

export function usePopupMode() {
    return useContext(PopupContext);
}
